import { Link } from 'react-router-dom';

export default function Privacidad() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <Link to="/" className="text-blue-600 hover:text-blue-800 font-medium">
            ← Volver a inicio
          </Link>
        </div>

        {/* Content */}
        <div className="bg-white shadow-sm rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            Política de Privacidad
          </h1>

          <div className="prose prose-blue max-w-none space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                1. Responsable del Tratamiento
              </h2>
              <p>
                El responsable del tratamiento de sus datos personales es:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Denominación social:</strong> AURION ENERGY S.L.</li>
                <li><strong>Sitio web:</strong> aurionenergy.es</li>
                <li><strong>Correo electrónico:</strong> info@aurionenergy.es</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                2. Finalidad del Tratamiento de Datos
              </h2>
              <p>
                Los datos personales que nos proporcione a través de nuestro sitio web serán tratados con las siguientes finalidades:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Gestión de consultas:</strong> Responder a las consultas, dudas y solicitudes de información que nos envíe a través de nuestros formularios de contacto.</li>
                <li><strong>Elaboración de presupuestos:</strong> Preparar y enviarle presupuestos personalizados de nuestros servicios de instalaciones fotovoltaicas y eficiencia energética.</li>
                <li><strong>Comunicaciones comerciales:</strong> Enviarle información sobre nuestros productos, servicios, ofertas y novedades, siempre que haya consentido expresamente recibir este tipo de comunicaciones.</li>
                <li><strong>Ejecución contractual:</strong> Gestionar y ejecutar la relación contractual que mantenemos con usted en caso de contratar nuestros servicios.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                3. Base Legal del Tratamiento
              </h2>
              <p>
                La base legal para el tratamiento de sus datos personales se fundamenta en:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Consentimiento del interesado:</strong> Al completar nuestros formularios y aceptar esta política de privacidad, usted otorga su consentimiento expreso para el tratamiento de sus datos personales.</li>
                <li><strong>Ejecución de un contrato:</strong> El tratamiento es necesario para la ejecución de un contrato en el que usted es parte o para la aplicación de medidas precontractuales (como la elaboración de presupuestos).</li>
                <li><strong>Interés legítimo:</strong> En el caso de comunicaciones comerciales, cuando exista una relación contractual previa y no haya manifestado su oposición.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                4. Datos Personales Recopilados
              </h2>
              <p>
                Los datos personales que podemos recopilar incluyen, sin carácter exhaustivo:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Datos identificativos: nombre y apellidos</li>
                <li>Datos de contacto: dirección de correo electrónico, número de teléfono, dirección postal</li>
                <li>Datos relativos a su vivienda o negocio: ubicación, consumo energético, características de la instalación</li>
                <li>Cualquier otra información que voluntariamente nos facilite a través de nuestros formularios o comunicaciones</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                5. Destinatarios de los Datos
              </h2>
              <p>
                Sus datos personales no serán cedidos ni comunicados a terceros, salvo en los siguientes casos:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Cuando sea necesario para la ejecución del servicio contratado (por ejemplo, instaladores, proveedores de equipos)</li>
                <li>Cuando exista obligación legal de hacerlo</li>
                <li>Cuando sea necesario para la defensa de reclamaciones o el ejercicio de acciones legales</li>
                <li>Proveedores de servicios tecnológicos que actúan como encargados del tratamiento (alojamiento web, servicios de correo electrónico, etc.)</li>
              </ul>
              <p>
                En todo caso, estos terceros estarán sujetos a obligaciones de confidencialidad y únicamente tratarán sus datos siguiendo nuestras instrucciones.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                6. Plazo de Conservación de los Datos
              </h2>
              <p>
                Sus datos personales serán conservados durante el tiempo necesario para cumplir con las finalidades para las que fueron recabados:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Consultas y presupuestos:</strong> Durante el plazo necesario para atender su solicitud y, en caso de no contratar nuestros servicios, durante un año adicional por si decidiera retomar el contacto.</li>
                <li><strong>Relación contractual:</strong> Durante la vigencia del contrato y posteriormente durante el plazo de prescripción de las acciones legales derivadas del mismo (generalmente 5 años).</li>
                <li><strong>Comunicaciones comerciales:</strong> Hasta que solicite la baja o revoque su consentimiento.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                7. Derechos del Interesado
              </h2>
              <p>
                De conformidad con el Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018, de Protección de Datos Personales y Garantía de los Derechos Digitales, usted tiene derecho a:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Derecho de acceso:</strong> Conocer qué datos personales estamos tratando sobre usted.</li>
                <li><strong>Derecho de rectificación:</strong> Solicitar la corrección de datos inexactos o incompletos.</li>
                <li><strong>Derecho de supresión:</strong> Solicitar la eliminación de sus datos cuando ya no sean necesarios para los fines para los que fueron recogidos.</li>
                <li><strong>Derecho de oposición:</strong> Oponerse al tratamiento de sus datos personales.</li>
                <li><strong>Derecho de limitación del tratamiento:</strong> Solicitar la limitación del tratamiento de sus datos en determinadas circunstancias.</li>
                <li><strong>Derecho a la portabilidad:</strong> Recibir sus datos personales en un formato estructurado y de uso común para transmitirlos a otro responsable.</li>
                <li><strong>Derecho a no ser objeto de decisiones automatizadas:</strong> No ser objeto de decisiones basadas únicamente en el tratamiento automatizado que produzcan efectos jurídicos o le afecten significativamente.</li>
              </ul>
              <p className="mt-4">
                Para ejercer cualquiera de estos derechos, puede dirigirse a nosotros mediante correo electrónico a <strong>info@aurionenergy.es</strong>, indicando en el asunto "Ejercicio de Derechos RGPD" y adjuntando copia de su DNI o documento identificativo equivalente.
              </p>
              <p>
                Asimismo, le informamos de su derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) si considera que el tratamiento de sus datos personales no se ajusta a la normativa vigente.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                8. Medidas de Seguridad
              </h2>
              <p>
                AURION ENERGY S.L. se compromete a adoptar las medidas técnicas y organizativas necesarias para garantizar la seguridad de sus datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, teniendo en cuenta el estado de la tecnología, la naturaleza de los datos almacenados y los riesgos a los que están expuestos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                9. Actualización de la Política de Privacidad
              </h2>
              <p>
                AURION ENERGY S.L. se reserva el derecho a modificar la presente Política de Privacidad para adaptarla a novedades legislativas, jurisprudenciales o interpretaciones de la Agencia Española de Protección de Datos. Cualquier modificación será publicada en esta página web con suficiente antelación a su aplicación.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                10. Consentimiento
              </h2>
              <p>
                Al utilizar nuestro sitio web y proporcionarnos sus datos personales, usted declara ser mayor de 14 años y que la información facilitada es verdadera, exacta, completa y actualizada. Asimismo, otorga su consentimiento expreso para el tratamiento de sus datos personales conforme a las finalidades y condiciones descritas en esta Política de Privacidad.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
